export default function WorkExperience({ experience }) {
  if (!experience) return null;

  return (
    <div
      style={{
        backgroundColor: 'var(--card-background, #fff)',
        borderRadius: 16,
        padding: '20px 24px',
        border: '1px solid var(--border-light, rgba(0,0,0,0.07))',
        boxShadow: 'var(--shadow-sm, 0 1px 6px rgba(0,0,0,0.05))',
      }}
    >
          <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--heading-primary, #111827)', marginBottom: 12 }}>
            Work Experience
          </div>
          {experience.workExperience &&
          typeof experience.workExperience !== 'string' ? (
            experience.workExperience?.map((item, index) => (
              <div key={index} style={{ padding: '8px 0', marginBottom: 8 }}>
                <div style={{ display: 'flex', color: 'var(--text-secondary, #6B7280)', fontSize: 13 }}>
                  <div style={{ flex: 1 }}>{item?.role?.name}</div>
                  <div>
                    {item?.from} - {item?.to || 'Present'}
                  </div>
                </div>

                <div style={{ display: 'flex', fontSize: 13 }}>
                  <div style={{ flex: 1, fontWeight: 500, color: 'var(--text-primary, #111827)' }}>{item.company.name}</div>
                  {item?.salary && (
                    <div style={{ color: 'var(--text-secondary, #6B7280)' }}>
                      Salary: {item?.salary?.name}
                    </div>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div style={{ padding: '8px 0', fontSize: 13, color: 'var(--text-primary, #111827)' }}>{experience.workExperience}</div>
          )}
    </div>
  );
}
